import React from "react";

import styles from "./shimmer.module.scss";

const Shimmer = (): JSX.Element => <span className={styles.shimmer} />;

export default Shimmer;
